<div class="cmd-backdrop" (click)="close.emit()">
  <div
    class="cmd-panel"
    role="dialog"
    aria-modal="true"
    aria-label="Paleta de comandos"
    ubFocusTrap
    (click)="$event.stopPropagation()"
    (keydown.arrowdown)="$event.preventDefault(); move(1)"
    (keydown.arrowup)="$event.preventDefault(); move(-1)"
    (keydown.enter)="$event.preventDefault(); runActive()"
  >
    <div class="cmd-search">
      <span class="cmd-search__icon" aria-hidden="true">⌕</span>
      <input
        #input
        type="text"
        class="cmd-search__input"
        autofocus
        autocomplete="off"
        spellcheck="false"
        placeholder="Buscar página, documentação, ação…"
        aria-label="Buscar página, documentação ou ação"
        role="combobox"
        aria-expanded="true"
        aria-controls="cmd-list"
        [attr.aria-activedescendant]="filtered().length ? 'cmd-opt-' + activeIndex() : null"
        [value]="query()"
        (input)="onInput(input.value)"
      />
      <span class="cmd-search__kbd mono">esc</span>
    </div>

    <div class="cmd-list ub-scroll" id="cmd-list" role="listbox" aria-label="Resultados" #list>
      @for (group of groups(); track group.title) {
        <div class="cmd-group">{{ group.title }}</div>
        @for (entry of group.items; track entry.command.id) {
          <button
            type="button"
            class="cmd-opt"
            role="option"
            [id]="'cmd-opt-' + entry.index"
            [attr.data-index]="entry.index"
            [attr.aria-selected]="isActive(entry.index)"
            [class.is-active]="isActive(entry.index)"
            (mouseenter)="highlight(entry.index)"
            (click)="select(entry.command)"
          >
            <span class="cmd-opt__icon" aria-hidden="true">{{ entry.command.icon }}</span>
            <span class="cmd-opt__label">{{ entry.command.label }}</span>
            @if (entry.command.hint) {
              <span class="cmd-opt__hint">{{ entry.command.hint }}</span>
            }
          </button>
        }
      } @empty {
        <div class="cmd-empty">Nada encontrado para “{{ query() }}”.</div>
      }
    </div>

    <div class="cmd-foot">
      <span><kbd class="mono">↑</kbd><kbd class="mono">↓</kbd> navegar</span>
      <span><kbd class="mono">↵</kbd> abrir</span>
      <span><kbd class="mono">esc</kbd> fechar</span>
    </div>
  </div>
</div>
